'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormattedMessage = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = require('ramda');

var _LanguageContext = require('../context/LanguageContext');

var _translate = require('../translate');

var _translate2 = _interopRequireDefault(_translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFormattedString = function getFormattedString(string, values) {
    var formattedString = string;

    (0, _ramda.forEachObjIndexed)(function (value, key) {
        formattedString = (0, _ramda.replace)(new RegExp('{' + key + '}', 'g'), value, formattedString);
    }, values);

    return formattedString;
};

var FormattedMessage = exports.FormattedMessage = function FormattedMessage(_ref) {
    var id = _ref.id,
        values = _ref.values,
        Component = _ref.textComponent;
    return _react2.default.createElement(
        _LanguageContext.LanguageContext.Consumer,
        null,
        function (_ref2) {
            var language = _ref2.language;
            return _react2.default.createElement(
                Component,
                null,
                _translate2.default[language][id] ? getFormattedString(_translate2.default[language][id], values) : id
            );
        }
    );
};

FormattedMessage.propTypes = {
    id: _propTypes2.default.string.isRequired,
    values: _propTypes2.default.object,
    textComponent: _propTypes2.default.any
};

FormattedMessage.defaultProps = {
    values: {},
    textComponent: 'span'
};